export default __webpack_public_path__ + "static/media/Build.f79956a9.svg";